import type { JSX } from 'react'

export const PlusIcon = (): JSX.Element => (
  <use href='#plus' height='100%' width='100%' />
)
